module.exports = __webpack_public_path__ + "static/media/UQ.917b4506.png";